import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

const sizeStyles = {
  sm: 'w-4 h-4',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
};

const colorStyles = {
  primary: 'text-primary-600',
  white: 'text-white',
  gray: 'text-gray-400',
  danger: 'text-red-500',
  success: 'text-emerald-500',
};

export default function LoadingSpinner({
  size = 'md',
  color = 'primary',
  overlay = false,
  message,
  className = '',
}) {
  const spinner = (
    <motion.div
      animate={{ rotate: 360 }}
      transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
      className={`flex items-center justify-center ${className}`}
    >
      <Loader2
        className={`${sizeStyles[size] || sizeStyles.md} ${colorStyles[color] || colorStyles.primary}`}
      />
    </motion.div>
  );

  if (overlay) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/70 dark:bg-gray-900/70 backdrop-blur-sm">
        {spinner}
        {message && (
          <p className="mt-3 text-sm text-gray-600 dark:text-gray-400">{message}</p>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center">
      {spinner}
      {message && (
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">{message}</p>
      )}
    </div>
  );
}
